module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-planner-face-83aad6c4d239d384c2c66313406b1c33.png";